import { SxProps, Theme } from '@mui/system';

const styles = {
  container: {
    width: '100%',
  },
  message: {
    textAlign: 'center',
    fontWeight: '500',
    fontSize: 18,
    color: 'grey.800',
    mb: '16px',
  },
} satisfies Record<string, SxProps<Theme>>;

export default styles;
